import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './SchemasList.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import PageTable from '../../../Shared/PageTable/PageTable';

function SchemasList(props: SchemasListProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();

    var testTraits = [
        "BREED_IDS",
        "TITLE",
        "DESCRIPTION",
        "CREATEDBY",
    ]

    useEffect(() => {
        if (auth.user?.userdata?.ROLE != "sysadmin") {
            navigate("/");
        }
    }, []);

    function createTraitColumn(trait: any) {
        if (trait != undefined) {
            let column: any = {
                label: t("admin.areas.schemaslist.table.headers." + trait),
                field: trait,
            };

            if (trait == "BREED_IDS") {
                column.override = (data: any) => {
                    return data.BREED_IDS?.split(",").join("").split("|").filter((i: string) => i != "").join(", ");
                }
            }
            
            return column;
        } else {
            return undefined;
        }
    }

    function createColumns() {
        let columns: any[] = [];
        testTraits.forEach((trait: string) => {
            columns.push(createTraitColumn(trait));
        });
        
        return columns;
    }

    return (
        <div className="dynschemas">
            <button className="btn btn-primary" onClick={() => navigate("/editdynschema/new")}>{t("admin.areas.schemaslist.buttons.create")}</button>
            <hr/>
            { auth.selectedBreed != undefined &&
                <PageTable
                    dataUrl={"/api/dynschema/getAllPaged/" + auth.selectedBreed}
                    onLineClick={(dataLine: any) => {
                        navigate("/editdynschema/" + dataLine.ID);
                    }}
                    options={{
                        showFields: [
                            ...createColumns(),
                        ],
                    }}
                    permaFilters={[
                        {
                            field: "BREED_IDS",
                            exact: false,
                            type: "and",
                            values: ["|" + auth.selectedBreed + "|"]
                        },
                    ]}
                    selectedTraits={testTraits}
                    clickable
                    defaultSortDirection="desc"
                    defaultSortField="ID"
                    hidePagination={false}
                    hidePagesize={false}
                    hideFilter={false}
                />
            }
        </div>
    );
}

class SchemasListProps {
    
}

export default SchemasList;